"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenerateTestModels = exports.dtoGetterSetterValidationHelper = exports.services = exports.UserEnums = exports.UserModels = exports.UIModels = exports.TenantEnums = exports.TenantModels = exports.SharedModels = exports.AuthEnums = exports.AuthModels = exports.interfaces = exports.UIDtoFactory = exports.Enums = exports.DtoBase = void 0;
var dto_1 = require("./dto");
Object.defineProperty(exports, "DtoBase", { enumerable: true, get: function () { return dto_1.DtoBase; } });
exports.Enums = __importStar(require("./enums"));
var factories_1 = require("./factories");
Object.defineProperty(exports, "UIDtoFactory", { enumerable: true, get: function () { return factories_1.UIDtoFactory; } });
exports.interfaces = __importStar(require("./interface"));
exports.AuthModels = __importStar(require("./models/auth"));
exports.AuthEnums = __importStar(require("./models/auth/enum"));
exports.SharedModels = __importStar(require("./models/shared"));
exports.TenantModels = __importStar(require("./models/tenants"));
exports.TenantEnums = __importStar(require("./models/tenants/enums"));
exports.UIModels = __importStar(require("./models/ui"));
exports.UserModels = __importStar(require("./models/users"));
exports.UserEnums = __importStar(require("./models/users/enums"));
exports.services = __importStar(require("./service"));
var dtoGetterSetterValidationHelper_1 = require("./testUtils/dtoGetterSetterValidationHelper");
Object.defineProperty(exports, "dtoGetterSetterValidationHelper", { enumerable: true, get: function () { return dtoGetterSetterValidationHelper_1.dtoGetterSetterValidationHelper; } });
var generateTestModels_1 = require("./testUtils/generateTestModels");
Object.defineProperty(exports, "GenerateTestModels", { enumerable: true, get: function () { return generateTestModels_1.GenerateTestModels; } });
